import axios from 'axios';
import firebase from 'firebase/compat/app';
import { createSearchAuth } from '@cardladder/shared/utils/searchAuth.util';

const searchAuth = createSearchAuth({ firebase, axios, mobileAppHeader: false });

export const {
  clearSearchAuthHeader,
  ensureMobileAppHeader,
  isFirebaseAuthExpiredError,
  createSessionExpiredError,
  handleExpiredAuthSession,
  setSearchAuthHeader,
  getHttpStatus,
  isSearchAuthError,
  isSessionExpiredError,
  withSearchAuthRetry,
} = searchAuth;
